// Login page constants
export const LOGIN_TITLE = 'Welcome Back';
export const LOGIN_SUBTITLE = 'Sign in to continue to Yes Boss';
export const GOOGLE_BUTTON_LABEL = 'Continue with Google';

// Analytics events
export const ANALYTICS_EVENTS = {
  LOGIN: 'login',
  LOGIN_ERROR: 'login_error'
};

// Error messages
export const ERROR_MESSAGES = {
  SIGN_IN: 'Error signing in with Google:',
  AUTH: 'Authentication error:'
};

// User defaults
export const USER_DEFAULTS = {
  SETUP_COMPLETED: false
};

// Paths
// Note: Using template literals for base paths that might change
const APP_BASE = ''; // Update this if your app has a base path
export const PATHS = {
  DASHBOARD: `${APP_BASE}/dashboard`,
  FIRST_TIME_SETUP: `${APP_BASE}/first-time-setup`,
  LOGIN: `${APP_BASE}/login`
};
